<template>
  <div class="page-content"  id="linkDetails">
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>监控中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/newLinkList'}">监控链接</el-breadcrumb-item>
      <el-breadcrumb-item>监控详情</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row>
      <!-- 计划信息 -->
      <el-col :span="24" style="margin-bottom: 20px;">
        <div style="font-size: 16px;color: #333333;display: flex;">
          <div class="iconDiv">
            .
          </div>
          计划信息
        </div>
      </el-col>
      <el-col :span="24">
        <el-card>

          <el-col :span="8">
            <div class="tenSize">
              <span class="fontColor">
                平台：
              </span>
              <span>
                {{this.$route.query.platform | platformChinese}}
              </span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="tenSize">
              <span class="fontColor">
                店铺：
              </span>
              <span>
                {{this.$route.query.shopname}}
              </span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="tenSize">
              <span class="fontColor">
                授权情况：
              </span>
              <span v-if="this.$route.query.shoptype == 1">
                已授权
              </span>
              <span v-else>
                非授权
              </span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="twoSize">
              <div class="fontColor" style="float: left;">
                商品名称：
              </div>
              <div style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;width: 80%;color: #1890ff;">
                <el-link :underline="false" :href="$route.query.link" target="_blank" type="primary">
                  {{$route.query.itemtitle}}
                </el-link>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="twoSize">
              <span class="fontColor">
                监控模式：
              </span>
              <span v-if="this.$route.query.monitoringType == 1">
                到手价
              </span>
              <span v-if="this.$route.query.monitoringType == 0">
                标价
              </span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="twoSize">
              <span class="fontColor">
                通知人：
              </span>
              <span>
                {{this.$route.query.noticeusername}}
              </span>
            </div>
          </el-col>
        </el-card>
      </el-col>

      <!-- 监控结果详情 -->
      <el-col :span="24" style="margin-bottom: 20px;margin-top: 20px;">
        <div style="font-size: 16px;color: #333333;display: flex;">
          <div class="iconDiv">
            .
          </div>
          计划详情
        </div>
      </el-col>
    </el-row>
    <el-col :span="24">
      <el-card>
        <div class="sku-info-main flex-start flex-vereical-center" style="display: flex;">
          SKU信息
          <div :class="['tag-heighthidden',openSku?'':'tag-heightauto']" style="margin-left: 10px;">
            <el-tag
              v-for="(item,index) in newSkulist"
              :key="index"
              :type="index==activetag?'':'info'"
              @click="linkMonitorSkuName(item,index)"
              effect="plain"
              size="medium"
            >{{ item }}</el-tag>
          </div>
          <span
            style="color:#108cee;cursor:pointer;margin-left:5px;"
            @click="openSku=!openSku"
          >{{openSku?'展开':'收起'}}</span>
        </div>
        <div style="width: 100%;">
          <el-button type="primary" @click="exportLinkMonitorDetailExcel" :loading="detailLoading" size="mini" style="margin: 8px 0;">下载数据</el-button>
          <div style="float: right;line-height: 44px;">
            选择日期
            <el-date-picker
              size="mini"
              value-format="yyyy-MM-dd"
              v-model="committime"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              :clearable="false"
              @change="changeData"
            ></el-date-picker>
          </div>
        </div>
        <el-table
          :data="tableData"
          ref="multipleTable"
          v-loading="dataLoading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          style="margin-top: 10px;width: 100%;"
          >

          <el-table-column label="序号" type="index" min-width="5%">
          </el-table-column>

          <el-table-column min-width="5%">
            <template slot-scope="scope">
              <span
                class="low-price"
                v-if="scope.row.lowpriceStatus==='1'"
                style="margin-right:10px"
              >低</span>
              <div style="width:100%" v-else>
                <span>&nbsp;</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="更新时间" min-width="14%">
            <template slot-scope="scope">
              <span v-if="scope.row.monitorTime">
                {{scope.row.monitorTime.substring(0,16)}}
              </span>
            </template>
          </el-table-column>

          <el-table-column label="商品信息/SKU信息" min-width="20%">
            <template slot-scope="scope">
              {{scope.row.skuTitle}}
            </template>
          </el-table-column>

          <el-table-column prop="priceSign" label="标价" min-width="8%">
          </el-table-column>

          <el-table-column prop="priceHeader" label="到手价" min-width="8%">
          </el-table-column>

          <el-table-column prop="checkPrice" label="限价" min-width="8%">
          </el-table-column>

          <el-table-column prop="status" label="优惠说明" min-width="14%">
            <template slot-scope="scope">
              <couponsZzj :zzjCoupons="scope.row.coupons"/>
            </template>
          </el-table-column>

          <el-table-column prop="status" label="状态" min-width="8%">
            <template slot-scope="scope">
              <span v-show="scope.row.skuStatus == '0'" style="color: #52c41a;">上架</span>
              <span v-show="scope.row.skuStatus == '2'" style="color: #e90e24;">下架</span>
            </template>
          </el-table-column>

          <el-table-column label="监控快照" min-width="10%">
            <template slot-scope="scope">
              <el-link :href="scope.row.islowpriceJt" target="_blank" type="primary" :underline="false" v-if="scope.row.islowpriceJt">违规截图</el-link>
              <span v-else>--</span>
            </template>
          </el-table-column>
        </el-table>
        <div v-show="this.tableData.length >= 1" class="bottom_page">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            :total="totalNum"
            layout="total, prev, pager, next,sizes, jumper">
          </el-pagination>
        </div>
      </el-card>
    </el-col>
    <!-- 各平台监控链接链接情况 -->
    <el-col :span="24" style="margin-bottom: 20px;margin-top: 20px;">
      <div style="font-size: 16px;color: #333333;display: flex;float: left;">
        <div class="iconDiv">
          .
        </div>
        价格走势图
      </div>
      <div style="float: right;padding-right: 20px;font-size: 16px;cursor: pointer;">
        <i class="el-icon-document" @click="getLinkNumByLowprice"></i>
        <i class="el-icon-download" style="padding-left: 20px;" @click="downLoadskuPrice"></i>
      </div>
    </el-col>
    <el-col :span="24">
      <el-card>
        <div>
          <div v-loading="captureLoading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading">
              <div
            v-if="nochartData"
            ref="capture"
            id="capture"
          >
            <div id="myCharts" style="width:100%;height:420px" v-if="nochartData"></div>
            <!-- lengend分页 -->
            <div style="width:95%;margin:auto;">
              <div
                class="flex-start"
                style="flex-wrap:wrap; position: relative; z-index: 99999;"
              >
                <div
                  v-for="(item,index) in lengendChart"
                  :key="item"
                  style="cursor:pointer;width:200px;"
                  @click="checkLengend(index)"
                >
                  <span class="leng-icon" :style="lengColor(index)"></span>
                  <el-tooltip class="item" effect="dark" :content="item" placement="top-start">
                    <span :style="lengendBoxStyle(index)" class="ellipsis lengendname">{{item}}</span>
                  </el-tooltip>
                </div>
              </div>
              <div class="paging-chart" style="float:right;">
                <i
                  class="el-icon-caret-left"
                  @click="prevchart(0)"
                  :style="disablechartprev(chartPage)"
                ></i>
                {{chartPage}}
                <i
                  class="el-icon-caret-right"
                  @click="prevchart(1)"
                  :style="disablechart(chartPage)"
                ></i>
              </div>
            </div>
          </div>
          <div class="nodata" v-if="!nochartData">
            <img src="@/assets/img/other/nodata.svg" />暂无数据
          </div>

          </div>

        </div>
      </el-card>
    </el-col>
  </div>
  <el-dialog title="数据详情" :visible.sync="byPlat" width="960px">
    <el-button @click="downLoadskuPrice" :loading="platformLoading" size="mini" style="margin-bottom: 8px;margin-top: 8px;margin-left: 4px;">下载数据</el-button>
    <div style="height: 647px;overflow: auto;">
      <el-table :data="byPlatData" style="margin-bottom: 60px;padding-left: 4px;padding-right: 4px;">
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column prop="monitor_time" label="日期"></el-table-column>
        <el-table-column prop="check_price" label="标价"></el-table-column>
        <el-table-column prop="price_header" label="到手价"></el-table-column>
      </el-table>
    </div>
  </el-dialog>
</div>

</template>

<script>
import { getNoHourTodayOneMonth } from "@/libs/date";
import { fetchGet } from "@/libs/reqCommon";
import { barOptionConfig } from "@/libs/echartOption/barOption.js";
import couponsZzj from "@/components/couponsZzj";


  export default {
    data() {
      return {
        skuName: '',
        chartPage: 1,
        lengendChart: [],
        captureLoading: true,
        committime: [],
        activetag: null,
        openSku: true,
        totalNum: 100,
        tableData: [],
        dataLoading: false,
        hcmNewMonitorShop: [],
        byPlat: false,
        byPlatData: [],
        platformLoading: false,
        detailLoading: false,
        pageNo: 1,
        currentPage: 1,
        pageSize: 10,
        newSkulist: [],
        pickerOptions: {
          shortcuts: [{
  					text: '今日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,1);
  					}
  				},{
  					text: '近7日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,7);
  					}
  				}, {
  					text: '近15日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,15);
  					}
  				}, {
  					text: '近30日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,30);
  					}
  				}, {
  					text: '近90日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,90);
  					}
  				}, {
  					text: '近365日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,365);
  					}
  				}],

        },
        nochartData: false,
        linkInfoData: {},
        lengActive: 0,
        checktruePage: 1,
      }
    },
    components: {
      couponsZzj
    },
    created(){
  		this.getRecentDate();
  	},
    mounted() {
      this.newMonitorList()
      this.linkMonitorSkuItemid()
      this.getnowData()

    },
    methods: {
      getRecentDate(picker,n){
        if (!n) {
          n = 7
        }
  			const end = new Date();
  			const start = new Date();
  			start.setTime(start.getTime() - 3600 * 1000 * 24 * n);
  			if(picker){
  				picker.$emit('pick', [start, end]);
  			}
  			if (n === 1) {
  				this.committime[0] = end;
  				this.committime[1] = end;
  			} else {
  				this.committime[0] = start;
  				this.committime[1] = end;
  			}
        console.log(this.committime)
  		},
      lengendBoxStyle(index) {
        return index === this.lengActive && this.checktruePage === this.chartPage
          ? { color: "#000" }
          : { color: "#ddd" };
      },
      lengColor(index) {
        let color = [
          "#3aa0ff",
          "#975fe4",
          "#36cbcb",
          "#4dcb73",
          "#fad337",
          "#8300d7",
          "#f2637b",
          "#ff9f7f",
          "#e7bcf3",
          "#9fe6b8",
          "#9d96f5",
          "#cbb99d",
          "#31b573",
          "#a8d59d",
          "#e1c81d",
          "#5ca341",
          "#7a7700",
          "#3aa0ff",
          "#975fe4",
          "#36cbcb"
        ];
        return { background: color[index % 17] };
      },
      disablechartprev(index) {
        return index === 1 ? { color: "#ddd" } : {};
      },
      disablechart(index) {
        return index === this.turePage ? { color: "#ddd" } : {};
      },
      getnowData() {
        // let time = getNoHourTodayOneMonth();
        // this.committime = [time[1], time[1]];
        this.loadinit()
      },
      checkLengend(val) {
        this.lengActive = val;
        let active = val + 20 * (this.chartPage - 1);
        this.selected = {};
        this.chartData.legend.forEach((item, index) => {
          this.selected[item] = index == active;
        });
        this.chartData.madeLegend.selected = this.selected;
        this.brokenLine(this.chartData);
        this.checktruePage = this.chartPage;
      },
      changeData() {
        this.loadinit()
        this.newMonitorList()
      },
      //折线图
      loadinit() {
        let series = [];
        let time = [];
        fetchGet("hcm/monitorLink/skuPriceTrend", {
          itemid: this.$route.query.itemid,
          startTime: this.$options.filters['fullTime'] (this.committime[0]),
          endTime: this.$options.filters['fullTime'] (this.committime[1])
        }).then(res => {
          this.captureLoading=false
          if (res.status === "10000") {
            this.nochartData = res.data.length === 0 ? false : true;
            this.byPlatData = res.data[0]
            res.data.forEach((item, index) => {
              time.push(
                item[0].monitor_time.substring(5, item[0].monitor_time.length - 3)
              );
              if (index === 0) {
                item.forEach((items, indexs) => {
                  series.push({
                    name: items.sku_title,
                    data: [
                      this.linkInfoData.monitoringType === "0"
                        ? Number(items.price_sign)
                        : Number(items.price_header)
                    ]
                  });
                });
              } else {
                item.forEach((items, indexs) => {
                  let findSku = false;

                  series.forEach((itemss, indexss) => {
                    if (items.sku_title === itemss.name) {
                      findSku = true;
                      series[indexss].data[index] =
                        this.linkInfoData.monitoringType === "0"
                          ? Number(items.price_sign)
                          : Number(items.price_header);
                    }
                  });
                  if (!findSku) {
                    //没有之前的sku数据
                    let data = [];
                    data[series[0].data.length] =
                      this.linkInfoData.monitoringType === "0"
                        ? Number(items.price_sign)
                        : Number(items.price_header);
                    series.push({
                      name: items.sku_title,
                      data: data
                    });
                  }
                });
              }
            });
            //取名字
            let name = [];
            series.forEach((itemss, indexss) => {
              name.push(itemss.name);
            });
            this.selected = {};
            name.forEach((item, index) => {
              this.selected[item] = index == 0;
            });
            this.lengendChart = name.slice(0, 20);
            this.chartData = {
              toolbox: false,
              type: "line",
              data: series,
              title: "",
              xData: time,
              legend: name,
              madeLegend: {
                show: false,
                data: name,
                selected: this.selected
              }
            };
            if (this.nochartData) {
              this.turePage = Math.ceil(name.length / 20);
              this.brokenLine(this.chartData);
            }
          }
        });
      },
      brokenLine(data) {
        let _this = this;
        this.$nextTick(() => {
          setTimeout(() => {
            _this.chartLine = _this.$echarts.init(
              document.getElementById("myCharts")
            );
            _this.chartLine.setOption(barOptionConfig(data));
            _this.chartLine.on("legendScroll", function(params) {
              let index = params.scrollDataIndex;
            });
          }, 200);
        });
      },
      linkMonitorSkuName(item, index) {
        console.log(index)
        this.dataLoading = true
        this.activetag = this.activetag == index ? null : index;
        this.skuName = item;
        this.pageNo = 1;
        this.pageSize = 10;
        this.currentPage = 1;
        if (this.activetag !== null) {
          let data = {
            skuName: this.skuName,
            pageNo: this.pageNo,
            pageSize: this.pageSize
          }
          if (this.committime[0]) {
            data.startTime = this.$options.filters['fullTime'] (this.committime[0]).substring(0,10)
          }
          if (this.committime[1]) {
            data.endTime = this.$options.filters['fullTime'] (this.committime[1]).substring(0,10)
          }
          this.getlinkMonitorSkuName(data);
        } else {
          let data = {
            pageNo: this.pageNo,
            pageSize: this.pageSize,
            itemid: this.$route.query.itemid
          }
          if (this.committime[0]) {
            data.startTime = this.$options.filters['fullTime'] (this.committime[0]).substring(0,10)
          }
          if (this.committime[1]) {
            data.endTime = this.$options.filters['fullTime'] (this.committime[1]).substring(0,10)
          }
          this.getProductSkuDetailData(data);
        }
      },
      getlinkMonitorSkuName(data) {
        data.itemid = this.$route.query.itemid;
        fetchGet("hcm/monitorLink/linkMonitorSkuName", data).then(res => {
          if (res.status === "10000") {
            this.dataLoading = false
            this.tableData = res.data.content
            this.totalNum = res.data.totalElements
            this.tableData.forEach(item => {
              item.coupons = item.coupons ? item.coupons.split(";") : [];
              item.couponsShop = item.couponsShop
                ? item.couponsShop.split(";")
                : [];
            });
          }
        });
      },
      getProductSkuDetailData(data) {
        fetchGet("hcm/monitorLink/getProductSkuDetailData", data).then(res => {
          if (res.status === "10000") {
            this.dataLoading = false
            this.tableData = res.data.content
            this.totalNum = res.data.totalElements
            let getnumbers = 0; //取出最新的sku
            this.tableData.forEach(item => {
              getnumbers =
                Number(item.numbers) > getnumbers
                  ? Number(item.numbers)
                  : getnumbers;
              item.islowpriceJt ? (item.islowpriceJt = [item.islowpriceJt]) : "";
              item.coupons = item.coupons ? item.coupons.split(";") : [];
              item.couponsShop = item.couponsShop
                ? item.couponsShop.split(";")
                : [];
            });
          }
        });
      },
      getLinkNumByLowprice() {
        this.byPlat = true
      },
      // 下载
      exportLinkMonitorDetailExcel() {
        this.detailLoading = true
        let params = {
          itemid: this.$route.query.itemid,
        };
        fetch({
          url: "hcm/monitorLink/exportLinkMonitorDetailExcel",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "blob",
          timeout: 60 * 1000 * 5
        }).then(res => {
          //下载
          let url = window.URL.createObjectURL(new Blob([res]));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", "监控链接.xlsx");
          document.body.appendChild(link);
          link.click();
          this.detailLoading = false
        });
      },
      // 下载
      downLoadskuPrice() {
        this.platformLoading = true
        let params = {
          itemid: this.$route.query.itemid,
          startTime: this.$options.filters['fullTime'] (this.committime[0]),
          endTime: this.$options.filters['fullTime'] (this.committime[1])
        };
        fetch({
          url: "hcm/monitorLink/downLoadskuPrice",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "blob",
          timeout: 60 * 1000 * 5
        }).then(res => {
          //下载
          let url = window.URL.createObjectURL(new Blob([res]));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", "价格走势.xlsx");
          document.body.appendChild(link);
          link.click();
          this.platformLoading = false
        });
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = `${val}`
        this.newMonitorList()
      },
      // 翻页
      handleSizeChange(val) {
        this.pageSize = `${val}`
        this.newMonitorList()
      },
      // table数据源
      newMonitorList() {
        this.dataLoading = true
        if (this.activetag !== null) {
          let data = {
            skuName: this.skuName,
            pageNo: this.pageNo,
            pageSize: this.pageSize
          }
          if (this.committime[0]) {
            data.startTime = this.$options.filters['fullTime'] (this.committime[0]).substring(0,10)
          }
          if (this.committime[1]) {
            data.endTime = this.$options.filters['fullTime'] (this.committime[1]).substring(0,10)
          }
          this.getlinkMonitorSkuName(data);
        } else {
          let data = {
            pageNo: this.pageNo,
            pageSize: this.pageSize,
            itemid: this.$route.query.itemid
          }
          if (this.committime[0]) {
            data.startTime = this.$options.filters['fullTime'] (this.committime[0]).substring(0,10)
          }
          if (this.committime[1]) {
            data.endTime = this.$options.filters['fullTime'] (this.committime[1]).substring(0,10)
          }
          this.getProductSkuDetailData(data);
        }
      },
      linkMonitorSkuItemid() {
        let params={
          itemid: this.$route.query.itemid,
        }
        fetch({
          url: "hcm/monitorLink/linkMonitorSkuItemid",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.newSkulist = data
          }
        }).catch(err => {

        })
      },
      // 柱状图
      drawLine(data) {
        let Xdata = []
        let seriesData = []
        if (data) {
          seriesData.push(data.proportion)
          Xdata.push(data.name)
        }
        console.log(seriesData)
        // 基于准备好的dom，初始化echarts实例
        let myChartDrawer = this.$echarts.init(document.getElementById('storeDetailsChart'))
        // 绘制条形图
        var option = {
          tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b}: {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            left: 10,
            data: ['价格正常']
          },
          // 数据
          series: [
            {
              name: '价格正常',
              type: 'pie',
              radius: ['50%', '70%'],
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: 'center'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: '30',
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: false
              },
              data: seriesData
            }
          ]
        };
        myChartDrawer.setOption(option);
      },
    },
  }
</script>
<style lang="scss">
  #linkDetails{
    $hintRed:#e90e24;
    //低
    .bottom_page{
        .el-pagination{
            text-align: right;
            padding: 20px 0;
        }
    }
    .low-price {
        color: #fff;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        background: $hintRed;
        border-radius: 50%;
        display: inline-block;
    }
    .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover {
      -webkit-box-shadow: none !important;
      box-shadow: none !important;
    }
    .flex-start {
      display: flex;
      justify-content: flex-start;
    }
    .leng-icon {
      display: inline-block;
      width: 12px;
      height: 12px;
      vertical-align: super;
      margin-right: 5px;
    }
    .lengendname {
      display: inline-block;
      width: 150px;
    }
    .el-tag {
      margin-left: 10px;
      margin-bottom: 10px;
      cursor: pointer;
      &:hover {
        color: #409eff;
        border-color: #c6e2ff;
        background-color: #ecf5ff;
      }
    }
    .sku-info-main {
      .el-input {
        width: 303px;
        margin-left: 5px;
      }
    }
    .tag-heighthidden {
      height: 28px;
      overflow: hidden;
      width: 88%;
    }
    .tag-heightauto {
      height: auto;
    }
    .sku-info-main {
      .el-input {
        width: 303px;
        margin-left: 5px;
      }
    }
    .el-table__empty-text {
      padding-top: 100px;
      background: url("../../../../assets/img/other/nodata.svg") no-repeat;
      background-position: center 66px;
    }
    .el-table th {
      background-color: #f2f6fe !important;
      color: #4a4b4c;
    }
    .page {
      padding: 20px;
      margin: 10px 0px 0px 0px;
      background-color: white;
    }

    .el-button--TheCustom {
      color: #666;
      border-color: #D9D9D9;
      background-color: #fff;
    }
    .el-button--TheCustom:hover  {
      color: #666;
      border-color: #ded2b8;
      background-color: #faf9f5;
    }
    .iconDiv {
      width: 5px;
      background-color: #333333;
      margin-right: 10px;
      height: 21px;
      margin-top: 4px;
    }
    .fontColor {
      color: #000000a5;
    }
    .tenSize {
      height: 22px;
      margin-bottom: 10px;
    }
    .twoSize {
      height: 22px;
      margin-bottom: 20px;
    }

    #dialog {
      .el-button--primary {
        color: #FFF;
        background-color: #bda571;
        border-color: #bda571;
      }
      .el-button--primary:hover {
        color: #FFF;
        background-color: #c0ae8a;
        border-color: #c0ae8a;
      }
    }
  }
</style>
